import React, {forwardRef, useState, useImperativeHandle} from 'react';
import { Checkbox, Divider, Form, Input, Message } from 'semantic-ui-react';
import { PAYMENT_METHOD } from '../../../utils/business';

export const BillingStep = forwardRef(({ initialData, shippingData }, ref) => {
    const [sameAsShipping, setSameAsShipping] = useState(initialData?.sameAsShipping ?? true);
    const [companyPurchase, setCompanyPurchase] = useState(initialData?.companyPurchase ?? false);
    const [company, setCompany] = useState(initialData?.company || '');
    const [dic, setDic] = useState(initialData?.dic || '');
    const [icdph, setIcdph] = useState(initialData?.icdph || '');
    const [address, setAddress] = useState(initialData?.address || '');
    const [city, setCity] = useState(initialData?.city || '');
    const [zip, setZip] = useState(initialData?.zip || '');
    const [paymentMethod, setPaymentMethod] = useState(initialData?.paymentMethod || PAYMENT_METHOD.CASH_ON_DELIVERY);
    const [localErrors, setLocalErrors] = useState({});

    useImperativeHandle(ref, () => ({
        validate: () => {
            const e = {};
            if (!sameAsShipping) {
                if (companyPurchase && !company) e.company = 'Zadajte názov spoločnosti';
                if (!address) e.address = 'Zadajte adresu';
                if (!city) e.city = 'Zadajte mesto';
                if (!zip) e.zip = 'Zadajte PSČ';
            }
            if (!paymentMethod) e.paymentMethod = 'Vyberte spôsob platby';
            setLocalErrors(e);
            return Object.keys(e).length === 0;
        },
        getValues: () => ({
            sameAsShipping,
            companyPurchase,
            company,
            dic,
            icdph,
            address: sameAsShipping ? shippingData.address : address,
            city: sameAsShipping ? shippingData.city : city,
            zip: sameAsShipping ? shippingData.zip : zip,
            paymentMethod,
        }),
    }));

    return (
        <Form>
            <Form.Field>
                <Checkbox
                    label='Fakturačné údaje sú rovnaké ako doručovacie'
                    checked={sameAsShipping}
                    onChange={(e, d) => setSameAsShipping(d.checked)}
                />
            </Form.Field>
            {!sameAsShipping && (
                <>
                    <Form.Field>
                        <Checkbox
                            label='Nakupujem na firmu'
                            checked={companyPurchase}
                            onChange={(e, d) => setCompanyPurchase(d.checked)}
                        />
                    </Form.Field>
                    {companyPurchase && (
                        <>
                            <Form.Field error={!!localErrors.company}>
                                <label>Názov spoločnosti *</label>
                                <Input name="company" value={company} onChange={(e) => setCompany(e.target.value)} />
                                {localErrors.company && <Message negative size='tiny' content={localErrors.company} />}
                            </Form.Field>
                            <Form.Group widths='equal'>
                                <Form.Field>
                                    <label>DIČ/IČO</label>
                                    <Input name="vat" value={dic} onChange={(e) => setDic(e.target.value)} />
                                </Form.Field>
                                <Form.Field>
                                    <label>IČ DPH</label>
                                    <Input value={icdph} onChange={(e) => setIcdph(e.target.value)} />
                                </Form.Field>
                            </Form.Group>
                        </>
                    )}
                    <Form.Field error={!!localErrors.address}>
                        <label>Ulica a číslo *</label>
                        <Input name="address" value={address} onChange={(e) => setAddress(e.target.value)} />
                        {localErrors.address && <Message negative size='tiny' content={localErrors.address} />}
                    </Form.Field>
                    <Form.Group widths='equal'>
                        <Form.Field error={!!localErrors.city}>
                            <label>Mesto *</label>
                            <Input name="city" value={city} onChange={(e) => setCity(e.target.value)} />
                            {localErrors.city && <Message negative size='tiny' content={localErrors.city} />}
                        </Form.Field>
                        <Form.Field error={!!localErrors.zip}>
                            <label>PSČ *</label>
                            <Input name="zip" value={zip} onChange={(e) => setZip(e.target.value)} />
                            {localErrors.zip && <Message negative size='tiny' content={localErrors.zip} />}
                        </Form.Field>
                    </Form.Group>
                </>
            )}

            <Divider />

            <Form.Field>
                <label>Spôsob platby *</label>
                <Form.Group inline>
                    {/* <Form.Field>
                        <Checkbox radio label='Platba kartou cez GoPay'
                            checked={paymentMethod === PAYMENT_METHOD.GOPAY}
                            onChange={() => setPaymentMethod(PAYMENT_METHOD.GOPAY)}
                        />
                    </Form.Field> */}
                    <Form.Field>
                        <Checkbox
                            radio
                            label='Dobierka'
                            name='pay'
                            checked={paymentMethod === PAYMENT_METHOD.CASH_ON_DELIVERY}
                            onChange={() => setPaymentMethod(PAYMENT_METHOD.CASH_ON_DELIVERY)}
                        />
                    </Form.Field>
                </Form.Group>
            </Form.Field>
        </Form>
    );
});